<template>
  <tr :id="guid">
    <td>{{ symbol }}</td>
    <td>{{ getFormatedDate }}</td>
    <td style="text-align: right">{{ dividend }}</td>
    <td style="text-align: right">{{ currency }}</td>
    <td>{{ description }}</td>
    <td>{{ imported }}</td>
    <td style="text-align: right">
      <button
        class="btn btn-danger btn-sm"
        @click="deleteSelectedId($event, guid)"
      >
        <font-awesome-icon icon="fa-solid fa-solid fa-trash" />
      </button>
    </td>
  </tr>
</template>

<script setup>
//VUE core
//import { defineProps } from 'vue';
import { defineProps, defineEmits, computed } from 'vue';
import appUtils from '../utils/appUtils';

const emit = defineEmits(['delete-id']);

//const props = defineProps(['symbol', 'description']);
const props = defineProps([
  'guid',
  'symbol',
  'description',
  'currency',
  'date',
  'dividend',
  'imported',
]);

const getFormatedDate = computed(function () {
  return appUtils.getFormatedDate(props.date);
});

function deleteSelectedId(event, value) {
  emit('delete-id', value);
}
</script>
